import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, FormControlLabel, Switch, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { FileUploadInput } from 'components'
import constants from 'constants/index'
import theme from 'theme'

const DocumentApprovalAttachment = ({ currentDocument }) => {
  const { control, errors, watch, setValue } = useFormContext()

  const collectSignedDocument = watch('collectSignedDocument')
  const status = currentDocument?.status
  const collectApproval = currentDocument?.collectApproval

  const { ACTIVE_STATUS_ID } = constants.documents

  const isActive = status === ACTIVE_STATUS_ID

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      {isActive && collectApproval && (
        <Alert variant="standard" severity="info">
          Este campo destina-se a documentos assinados fisicamente
          (papel/manuscrito) ou com assinatura digital ICP-Brasil (certificado
          A1/A3 emitido por autoridade certificadora credenciada).
        </Alert>
      )}

      {!isActive ? (
        <Alert variant="standard" severity="info">
          Para enviar a assinatura, o documento precisa estar ativo.
        </Alert>
      ) : !collectApproval ? (
        <Alert variant="standard" severity="info">
          O envio da assinatura só fica disponível se o documento estiver
          coletando aprovações.
        </Alert>
      ) : (
        <>
          <Controller
            as={
              <FormControlLabel
                label="Habilitar envio do documento assinado fisicamente ou padrão ICP-Brasil"
                labelPlacement="end"
                control={<Switch color="primary" />}
              />
            }
            name="collectSignedDocument"
            control={control}
          />

          {collectSignedDocument && (
            <>
              <FileUploadInput
                title="Arraste e solte ou selecione o documento assinado"
                controlName="signedDocument"
                accept={constants.validations.FILE_TYPES_DOCS}
                hasDownloadFile
                onRemoveApiFile={
                  currentDocument?.signedDocument?.fileInfo
                    ? () => setValue('signedDocument', null)
                    : undefined
                }
              />

              <Controller
                as={
                  <TextField
                    label="Link para o documento assinado"
                    fullWidth
                    variant="outlined"
                    error={!!errors?.signedDocumentLink}
                    helperText={errors?.signedDocumentLink?.message}
                  />
                }
                name="signedDocumentLink"
                control={control}
                defaultValue=""
              />
            </>
          )}
        </>
      )}
    </Box>
  )
}

export default DocumentApprovalAttachment
